import Spinner from '@preqin/ui-components/cjs/core/Spinner';

import styles from './oidc.module.scss';

const Loading = () => (
  <div className={styles.oidcComponentWrapper}>
    <Spinner type={'border'} size={'sm'} color={'neutral'} textPosition={'bottom'} text={'Loading Authentication...'} />
  </div>
);

export default Loading;
